import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Checkbox from '../Checkbox/Checkbox';
import { requiresMarketingConsent } from '../../lib/consent';
import { useLocale } from '../../contexts/LocaleContext';
import { useMarketingOptIn } from '../../contexts/MarketingOptInContext';
import styles from './MarketingOptInCheckbox.module.scss';

interface MarketingOptInCheckboxProps {
  className?: string;
}

/**
 * Marketing email opt-in checkbox shown to users in GDPR jurisdictions (EU/UK).
 * Unchecked by default — users must actively opt in. Uses OneTrust geo-detection
 * as the primary signal, falling back to locale context country.
 *
 * Reads and writes opt-in state from MarketingOptInContext.
 */
export default function MarketingOptInCheckbox({ className }: MarketingOptInCheckboxProps) {
  const { t } = useTranslation();
  const { country } = useLocale();
  const { marketingEmailsOptedIn, setMarketingEmailsOptedIn } = useMarketingOptIn();

  if (!requiresMarketingConsent(country)) {
    return null;
  }

  return (
    <Checkbox
      checked={marketingEmailsOptedIn ?? false}
      onChange={setMarketingEmailsOptedIn}
      label={t('i_agree_to_receive_marketing_emails')}
      className={classNames(styles.marketingOptInCheckbox, className)}
    />
  );
}
